import { MRT_TableOptions } from 'mantine-react-table';
import { ResourceRowFragmentFragment } from '@app/types/blackroom-api';

import * as tableStylesAPI from '../styles/index.css';
import { PAGE_SIZE } from '../types';

const baseConfig = {
  defaultColumn: {
    maxSize: 400,
    minSize: 80,
    size: 150,
  },
  displayColumnDefOptions: {
    'mrt-row-expand': {
      size: 10,
      minSize: 10,
    },
  },
  rowVirtualizerOptions: { overscan: PAGE_SIZE },
  getRowId: (originalRow) => originalRow.id,
  mantineSelectCheckboxProps: {
    radius: 'xs',
    size: 'sm',
    __vars: {
      '--mantine-cursor-type': 'pointer',
    },
  },
  mantineFilterCheckboxProps: {
    __vars: {
      '--mantine-cursor-type': 'pointer',
    },
  },
  mantinePaperProps: {
    style: {
      border: 'none',
      boxShadow: 'none',
      borderRadius: 8,
      overflow: 'hidden',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: 'transparent',
    },
  },
  mantineTableHeadCellProps: {
    className: tableStylesAPI.tableHeader,
  },
  mantineTableHeadRowProps: {
    className: tableStylesAPI.tableHeaderRow,
  },
  enablePagination: false,
  enableBottomToolbar: false,

  enableRowVirtualization: true,
  enableExpanding: true,
  manualSorting: true,
} as Partial<MRT_TableOptions<ResourceRowFragmentFragment>>;

export default baseConfig;
